document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-apex-view]');
  if (!toggle) return;
  const media = toggle.closest('.apex-editorial-hero__media');
  if (!media) return;
  media.classList.toggle('is-night', toggle.dataset.apexView === 'night');
  media.querySelectorAll('[data-apex-view]').forEach(button => button.setAttribute('aria-pressed', String(button === toggle)));
});
function updateApexSizerGuides() {
  document.querySelectorAll('[data-apex-size-guide]').forEach(guide => {
    const section = document.getElementById('MainProduct-' + guide.dataset.apexSizeGuide);
    const notice = guide.querySelector('[data-apex-sizer-notice]');
    if (!section || !notice) return;
    const values = Array.from(section.querySelectorAll('variant-selects select')).map(select => select.value);
    notice.hidden = !values.some(value => value.toLowerCase().includes('ring sizer'));
  });
}
document.addEventListener('change', event => {
  if (event.target.closest('variant-selects')) updateApexSizerGuides();
});
updateApexSizerGuides();
